<template>
  <!-- 业务咨询 -->
  <div class="operation_consult_box">
    <div class="box_top">
      <div class="text">请填写您的业务需求</div>
    </div>
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-position="top"
      class="form_box"
      v-loading="loading"
    >
      <div class="form_items">
        <el-form-item label="您的项目需求所在行业" prop="industry">
          <div class="tag_box">
            <div
              class="tag_item"
              v-for="(v, k) in hyList"
              :key="k"
              @click="form.industry = v.value"
              :class="form.industry == v.value ? 'this' : ''"
            >
              {{ v.label }}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="公司名称" prop="companyName">
          <el-input
            v-model="form.companyName"
            placeholder="请输入您的单位/公司名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="项目所在地" prop="areaCode">
          <el-cascader
            class="form_block"
            :options="areaCode"
            v-model="form.areaCode"
            placeholder="请选择省市区"
            @change="areaChoseHandler"
            separator="-"
            :props="{
              value: 'name',
              label: 'name',
            }"
            filterable
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="您的姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
        </el-form-item>
        <el-form-item label="email" prop="email">
          <el-input
            v-model="form.email"
            placeholder="请输入您的邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input
            v-model="form.phone"
            oninput="if(value.length>11)value=value.slice(0,11)"
            onkeyup="this.value = this.value.replace(/[^\d]/g,'');"
            placeholder="请输入您的联系方式"
          ></el-input>
        </el-form-item>
        <el-form-item label="问题描述" prop="problemDesc">
          <el-input
            v-model="form.problemDesc"
            type="textarea"
            class="form_textarea"
            placeholder="请输入您想咨询的问题"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form_btn">
        <el-button type="primary" class="btn_style" @click="submitForm"
          >提交</el-button
        >
      </div>
    </el-form>
  </div>
</template>
<script>
import chinaJson from "@/assets/js/pca-code.json";
import { sendEmailMsg } from "@/api/api.js";
export default {
  data() {
    const checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (!value) {
        return callback();
      } else {
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的邮箱格式"));
        }
      }
    };
    return {
      loading: false,
      areaCode: chinaJson,
      hyList: [
        { label: "城市", value: "城市" },
        { label: "医疗", value: "医疗" },
        { label: "金融", value: "金融" },
        { label: "园区", value: "园区" },
        { label: "其他", value: "其他" },
      ],
      form: {
        industry: "",
        companyName: "",
        areaCode: [],
        location: "",
        name: "",
        email: "",
        phone: "",
        problemDesc: "",
      },
      rules: {
        industry: [
          { required: true, message: "请选择所在行业", trigger: "change" },
        ],
        companyName: [{ required: true, message: "请输入", trigger: "blur" }],
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        phone: [{ required: true, message: "请输入", trigger: "blur" }],
        problemDesc: [{ required: true, message: "请输入", trigger: "blur" }],
        email: [{ validator: checkEmail, trigger: "blur" }],
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    areaChoseHandler(e) {
      this.$set(this.form, "location", e.join("-"));
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          sendEmailMsg(this.form).then((res) => {
            // console.log(res);
            if (res.code == 200) {
              this.$message({
                message:
                  "感谢您的填写，邮件已发送成功，我们会根据您填写的信息进行回复/回电，请耐心等待，期待与您的合作！",
                type: "success",
                duration: "4000",
              });
              this.loading = false;
              this.$emit("closeDialog", "submit");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.operation_consult_box {
  float: left;
  width: 100%;
  height: 100%;
  & > div {
    float: left;
    width: 100%;
  }
  .box_top {
    height: 176px;
    position: relative;
    z-index: 1;
    @include backgroundUrl("operation/bg_diolog_top.png", 100%, auto);
    .text {
      float: left;
      width: 100%;
      text-align: center;
      margin-top: 112px;
      font-size: 20px;
      font-weight: bold;
      color: #333;
    }
  }
  .form_box {
    float: left;
    width: 100%;
    height: calc(100% - 161px);
    background: #fff;
    position: relative;
    z-index: 2;
    border-radius: 16px;
    margin-top: -15px;
    padding-top: 20px;
    .form_items {
      width: calc(100% - 4px);
      margin-right: 4px;
      padding: 0 35px 0 28px;
      height: calc(100% - 92px);
      overflow-y: auto;
      .el-form-item {
        margin-bottom: 14px;
        float: left;
        width: 100%;
        ::v-deep .el-form-item__label {
          line-height: 22px;
        }
        .tag_box {
          float: left;
          width: 100%;
          .tag_item {
            float: left;
            width: 76px;
            height: 36px;
            line-height: 34px;
            text-align: center;
            border-radius: 30px;
            background: #edf2f8;
            border: 1px solid #edf2f8;
            font-size: 14px;
            color: #7189ad;
            cursor: pointer;
            margin-right: 15px;
            &:nth-child(5n) {
              margin-right: 0;
            }
            &.this {
              border-color: #0467ff;
              background: #d4e8ff;
              color: #0d7bff;
            }
          }
        }
      }
      &::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 8px;
      }
      &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 32px;
        background: #c1c1c1;
      }
      &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        border-radius: 32px;
        background: #f1f1f1;
      }
    }
    .form_btn {
      float: left;
      width: 100%;
      @include flexBoxCenter(center, center);
      margin: 28px 0 20px;
      .btn_style {
        float: left;
        border-radius: 6px;
        border: 1px solid #9ac9ff;
        background: #0467ff;
        width: 136px;
        height: 44px;
        line-height: 42px;
        text-align: center;
        padding: 0;
        font-size: 18px;
      }
    }
  }
}
</style>
